export const GET_MINI_FAQ = {
  REQUEST: 'GET_MINI_FAQ_REQUEST',
  SUCCESS: 'GET_MINI_FAQ_SUCCESS',
  FAILURE: 'GET_MINI_FAQ_FAILURE',
};
